import React from "react";
import { Home } from "lucide-react";
import FaqManager from "../Components/FaqManager";

// Sirf HOME PAGE ke FAQ.
// Course wale FAQ: Course Content > course edit/add > "FAQ" section me.
const FaqManagementPage = () => {
  return (
    <div className="space-y-4">
      <div>
        <h2 className="flex items-center gap-2 text-lg font-semibold text-slate-200">
          <Home size={18} className="text-[#1ec1d1]" />
          Home Page FAQs
        </h2>
        <p className="mt-1 text-xs text-slate-500">
          Ye FAQ website ke home page par dikhte hain. Kisi course ke FAQ
          add karne ke liye <span className="text-slate-300">Course Content</span>{" "}
          me us course ko open karo aur wahan “FAQ” section use karo.
        </p>
      </div>

      <div className="admin-card rounded-xl p-4">
        <FaqManager course="general" />
      </div>
    </div>
  );
};

export default FaqManagementPage;